import "./style.css";
import {baseURL,newImgUrl} from "../../constants/index"

export function AISText() {
  return (
    <div className="data_detail">
      <div className="detail">
        <span className="d_title_data">AIS船舶监测</span>
        <span className="d_tag">分类：数据产品 &nbsp; 2017/09/26</span>
      </div>
      <div className="d_txt_data">
        <p>
          基于exactEarth公司提供高质量的天基AIS数据，融合德国Fleetmon、英国IHS或希腊Marinetraffic岸基AIS数据，向用户提供最全面的全球AIS船位跟踪服务。
        </p>
        <p>&nbsp;</p>
        <p>
          自2010年7月来不间断累计天基AIS数据存档超过150亿条，目前有来自全球50多个国家，超过100家用户，行业覆盖军方、政府单位、高校、研究所、港口、物流公司、期货、保险等。
        </p>
        <p>&nbsp;</p>
        <p>（一）天基简介</p>
        <p>
          天基AIS是一种船舶定位技术，通过低轨道的卫星接收船舶发送的AIS报文信息，卫星将接收和解码AIS报文信息转发给相应的地球站，从而让陆地管理机构掌握船舶的相关动态信息，实现对远海海域航行船舶的监控。
        </p>
        <p>
          <img
            className="d_pic"
            src={baseURL+newImgUrl+"983ec607-8dc2-4708-86e8-c76879cb2c41.png"}
          />
        </p>
        <p>&nbsp;</p>
        <p>（二）天基AIS性能</p>
        <p>
          (1)高质量的服务：提供的数据信息丰富，并且能够检查船舶发送的位置信息的完整性；
        </p>
        <p>
          (2)对用户限制少:卫星AIS不是点对点系统，用户不需要支付任何电信费用；
        </p>
        <p>(3)覆盖面广：系统可以达到全球覆盖，包括极地区域。</p>
        <p>&nbsp;</p>
        <p>（三）卫星星座简介</p>
        <p>(1)与美国铱星（Iridium）合作；</p>
        <p>
          (2)现在轨75颗星携带AIS收发器，均匀分布在地球轨道上，保证信号稳定；
        </p>
        <p>(3)一代卫星+58颗铱星（二代实时卫星）共同运行+7颗备份；</p>
        <p>(4)数据服务中心：2个。</p>
        <p>
          <img
            className="d_pic"
            src={baseURL+newImgUrl+"c0df34e8-c192-4239-9dfc-7659a35c169e.png"}
          />
        </p>
        <p>&nbsp;</p>
        <p>（四）星座特色</p>
        <p>(1)拥有全世界唯一 一颗赤道轨迹AIS卫星；</p>
        <p>(2)其中一个天基在国际空间站上（超大功率）；</p>
        <p>(3)高效推送中国南海区域数据；</p>
        <p>(4)地面固定岸站：全球各地分布28个地面站。</p>
        <p>&nbsp;</p>
        <p>（五）AIS数据组成</p>
        <p>(1)实时数据</p>
        <p>
          使客户能够随时监控地球上任何地区的船只，弥补岸基AIS对远洋的监控不足。监控船舶数30万量级。
        </p>
        <p>
          <img
            className="d_pic"
            src={baseURL+newImgUrl+"b103934a-afe1-4da2-b581-6c3549607842.png"}
          />
        </p>
        <p>&nbsp;</p>
        <p>(2)历史数据</p>
        <p>
          自2010年7月5日开始exactEarth提供卫星AIS&nbsp;数据商业服务，已经累计存档超过150亿条AIS报文信息，跟踪超过30万艘不同船舶。目前可根据常规字段对数据进行提取与打包，灵活访问存档数据：
        </p>
        <p>✸日期和时间范围</p>
        <p>✸船舶类型</p>
        <p>✸船舶MMSI列表</p>
        <p>✸AIS报文类型</p>
        <p>✸地理区域</p>
        <p>✸国家</p>
        <p>
          <img
            className="d_pic"
            src={baseURL+newImgUrl+"67cf584d-c54a-47a4-9e2c-3daa411fbbf5.png"}
          />
        </p>
        <p>&nbsp;</p>
        <p>（六）数据推送方式</p>
        <p>(1)使用UniProxy包</p>
        <p>
          实时数据推送方式如下：即在服务器安装UniProxy包，即可在客户端通过socket服务来接收实时推送的AIS数据。
        </p>
        <p>(2)使用FTP</p>
        <p>
          FTP方式，即我们把解析后数据推送到指定的FTP上，用户以SFTP模式登录到FTP，随时下载使用解析后的数据。
        </p>
        <p>&nbsp;</p>
        <p>（七）数据WebService服务</p>
        <p>
          公司依托GIS强大的技术优势，开发了基于GIS的AIS和S57海图的WebService服务，其后台存储了自2010年以来所有的存档AIS数据和可扩充的S57海图库。
        </p>
        <p>
          公司提供船舶专题图图WMS接口、任意区域内船舶查询及下载接口、轨迹查询接口、历史轨迹下载接口等多种服务接口，用户可以基于此服务定制开发信息系统和订阅数据。
        </p>
        <p>
          <img
            className="d_pic"
            src={baseURL+newImgUrl+"d5f1469b-837f-459a-b5a7-59d646075ae0.png"}
          />
        </p>
        <p>
          <b>船舶专题图</b>
        </p>
        <p>&nbsp;</p>
        <p>（八）数据订购方式</p>
        <p>(1)海域面积</p>
        <p>✸全球数据（全球海域）。</p>
        <p>✸区域数据（黄海、南海等）。</p>
        <p>✸服务计费依据：海域面积（平方海里）。</p>
        <p>(2)船舶数量</p>
        <p>✸服务计费依据：数量和推送时间间隔。</p>
        <p>✸比如：1000艘船、15分钟更新一次。</p>
        <p>(3)船舶类型</p>
        <p>
          ✸服务计费依据：类型和推送时间间隔。例如所有集装箱船、15分钟更新一次。
        </p>
        <p>
          ✸类型：商业、商品、散装、集装箱、油轮、原油运输船、液化天然气、液化石油气、乘客等。
        </p>
      </div>
    </div>
  );
}
